export const FETCHING_TEMPLATES = "FETCHING_TEMPLATES";
export const CREATING_TEMPLATE = "CREATING_TEMPLATE";
export const UPDATING_TEMPLATE = "UPDATING_TEMPLATE";
